var map = {
	"./arrow-down-blue.svg": 410,
	"./arrow-down-grey.svg": 411,
	"./arrow-right-white.png": 412,
	"./arrow-right.svg": 413,
	"./bg_desktop.png": 206,
	"./bg_phone.png": 207,
	"./big_kwikcorn.png": 209,
	"./black_logo.png": 202,
	"./blue-loader.svg": 210,
	"./circle-grey.svg": 414,
	"./circle.svg": 415,
	"./coinbaseWalletIcon.svg": 130,
	"./dropdown-blue.svg": 416,
	"./dropdown.svg": 417,
	"./dropup-blue.svg": 418,
	"./ethereum-logo.png": 211,
	"./fortmaticIcon.png": 131,
	"./kswap_logo_black.png": 419,
	"./kswap_logo_white.png": 420,
	"./link.svg": 421,
	"./magnifying-glass.svg": 422,
	"./menu.svg": 423,
	"./metamask.png": 208,
	"./noise.png": 212,
	"./plus-blue.svg": 424,
	"./plus-grey.svg": 425,
	"./portisIcon.png": 132,
	"./question-mark.svg": 426,
	"./question.svg": 427,
	"./spinner.svg": 428,
	"./svg-path-mobile.svg": 213,
	"./svg-path.svg": 214,
	"./token-list/lists-dark.png": 429,
	"./token-list/lists-light.png": 430,
	"./token-logo.png": 134,
	"./trustWallet.png": 431,
	"./walletConnectIcon.svg": 133,
	"./x.svg": 432,
	"./xl_kwik.png": 215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 176;